import * as swcHelpers from '@swc/helpers';
import { getMaxSelectableQuantity } from '../../utils/get-max-selectable-quantity.js';

var getActions = (dispatch)=>{
    const updatePurchaseType = (purchaseType)=>{
        dispatch({
            type: 'setPurchaseType',
            payload: {
                purchaseType
            }
        });
        dispatch({
            type: 'updateAllValidations'
        });
        dispatch({
            type: 'resetErrors'
        });
    };
    const updatePrescriptionAttribute = (eyeSide, attribute, value)=>{
        const payload = {
            eyeSide,
            attribute,
            value
        };
        dispatch({
            type: 'setPrescriptionAttribute',
            payload
        });
        dispatch({
            type: 'updateStockStatus',
            payload: {
                eyeSide,
                stockIndicatorStatus: undefined
            }
        });
        dispatch({
            type: 'resetFetchedSku',
            payload: {
                eyeSide
            }
        });
        dispatch({
            type: 'updateIsConfiguratorValid'
        });
    };
    const updateSelectedQuantity = (eyeSide, quantity)=>{
        dispatch({
            type: 'setSelectedQuantity',
            payload: {
                eyeSide,
                quantity
            }
        });
        dispatch({
            type: 'updateIsConfiguratorValid'
        });
    };
    const updateColumnCheckbox = (eyeSide, isEnabled)=>{
        dispatch({
            type: 'setColumnCheckbox',
            payload: {
                eyeSide,
                isEnabled
            }
        });
        dispatch({
            type: 'updateIsConfiguratorValid'
        });
    };
    const updateDeliveryInterval = (deliveryInterval)=>{
        dispatch({
            type: 'setDeliveryInterval',
            payload: {
                deliveryInterval
            }
        });
        dispatch({
            type: 'updateIsConfiguratorValid'
        });
    };
    const updateQueryResult = (_param)=>{
        var { eyeSide , maxOrderableQuantity  } = _param, result = swcHelpers.objectWithoutProperties(_param, [
            "eyeSide",
            "maxOrderableQuantity"
        ]);
        dispatch({
            type: 'setQueryLoading',
            payload: {
                eyeSide,
                loading: false
            }
        });
        if ('error' in result) {
            dispatch({
                type: 'updateQueryError',
                payload: {
                    eyeSide,
                    error: result.error
                }
            });
            return;
        }
        const { sku , allowBackOrder , availableQuantity , stockIndicatorStatus  } = result.prescriptionCLProduct;
        const maxSelectableQuantity = getMaxSelectableQuantity({
            allowBackOrder,
            availableQuantity,
            maxOrderableQuantity
        });
        dispatch({
            type: 'updateFetchedSku',
            payload: {
                eyeSide,
                sku
            }
        });
        dispatch({
            type: 'updateStockStatus',
            payload: {
                eyeSide,
                stockIndicatorStatus
            }
        });
        dispatch({
            type: 'updateQueryError',
            payload: {
                eyeSide,
                error: undefined
            }
        });
        dispatch({
            type: 'updateMaxSelectableQuantity',
            payload: {
                eyeSide,
                maxSelectableQuantity
            }
        });
        dispatch({
            type: 'updateIsConfiguratorValid'
        });
    };
    const triggerValidationErrors = ()=>{
        dispatch({
            type: 'updateAllValidations'
        });
        dispatch({
            type: 'triggerErrors'
        });
    };
    const setQueryLoading = ({ eyeSide , loading  })=>{
        dispatch({
            type: 'resetFetchedSku',
            payload: {
                eyeSide
            }
        });
        dispatch({
            type: 'setQueryLoading',
            payload: {
                eyeSide,
                loading
            }
        });
    };
    return {
        updatePurchaseType,
        updatePrescriptionAttribute,
        updateColumnCheckbox,
        updateSelectedQuantity,
        updateDeliveryInterval,
        updateQueryResult,
        triggerValidationErrors,
        setQueryLoading
    };
};

export { getActions };
//# sourceMappingURL=actions.js.map
